import React from 'react'
import experience from '../../../../assets/experience'
import ExternalLink from '../../../common/ExternalLink/ExternalLink'
import Divider from '../../../common/Divider/Divider'
// import { useStorageChild } from '../../../../hooks/useStorage'

import './Experience.scss'

const Experience = () => {
  // const { image: resumeUrl } = useStorageChild('me', 'Cardarelli-Jason_Resume-Web_260711.pdf')

  return (
    <>
      {experience.map((job, i) => {
        return (
          <React.Fragment key={job.company}>
            <div className='job'>
              <div className='company'>
                {job.url ? (
                  <ExternalLink label={job.company} url={job.url} />
                ) : (
                  <span>{job.company}</span>
                )}
                <span className='location small'>{job.location}</span>
              </div>
              <div className='positions'>
                {job.positions.map((position) => {
                  return (
                    <div className='position' key={position.title}>
                      <span className='title'>{position.title}</span>
                      <span className='date-range small'>
                        {position.startDate && (
                          <>
                            <span>{position.startDate.split(' ')[1]}</span>
                            <span> &ndash; </span>
                          </>
                        )}
                        <span>
                          {position.endDate.includes(' ')
                            ? position.endDate.split(' ')[1]
                            : position.endDate}
                        </span>
                      </span>
                    </div>
                  )
                })}
              </div>
            </div>
            {/* Don't show Divider after final item */}
            {i + 1 !== experience.length && <Divider type='horizontal' />}
          </React.Fragment>
        )
      })}

      {/* {resumeUrl && (
        <div className='resume-footer'>
          <ExternalLink label='Download Resume (PDF)' url={resumeUrl} />
        </div>
      )} */}
    </>
  )
}

export default Experience
